var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButtonRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play_RED_2",
    "data-name": "Play RED 2",
    transform: "translate(-1636 -528)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1638 530)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "play-circle-sharp",
    d: "M62,48A14,14,0,1,0,76,62,14.016,14.016,0,0,0,62,48ZM58.231,67.923V56.077L67.923,62Z",
    transform: "translate(1588 480)",
    fill: "#eb3c37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonRed);
export default __webpack_public_path__ + "static/media/play-button-red.c376bde5a7196bf80cc47e8fd5fe5c47.svg";
export { ForwardRef as ReactComponent };